import React, { useState } from "react"
import { Box, Checkbox } from "@mui/material"
import { GalleryImage } from "@/features/gallery/hooks/useGalleryImages"

interface Props {
  image: GalleryImage
  selected: boolean
  onSelect: (img: GalleryImage) => void
  onClick: (img: GalleryImage) => void
}

const GalleryImageTile: React.FC<Props> = ({ image, selected, onSelect, onClick }) => {
  const [hovered, setHovered] = useState(false)
  const showCheckbox = hovered || selected
  const isVideo = image.mediaType === "video"

  return (
    <Box
      sx={{
        position: "relative",
        aspectRatio: "1",
        overflow: "hidden",
        cursor: "pointer",
        bgcolor: "action.hover",
        userSelect: "none"
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}>
      {isVideo ? (
        <Box
          component="video"
          src={image.url}
          muted
          controls
          preload="metadata"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
            transition: "transform 0.15s ease, border-radius 0.15s ease",
            transform: selected ? "scale(0.88)" : "scale(1)",
            borderRadius: selected ? "8px" : "0px"
          }}
        />
      ) : (
        <Box
          component="img"
          src={image.url}
          alt={image.productName}
          loading="lazy"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
            transition: "transform 0.15s ease, border-radius 0.15s ease",
            transform: selected ? "scale(0.88)" : "scale(1)",
            borderRadius: selected ? "8px" : "0px"
          }}
          onClick={() => onClick(image)}
        />
      )}

      {selected && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            border: "3px solid",
            borderColor: "primary.main",
            borderRadius: "8px",
            pointerEvents: "none"
          }}
        />
      )}

      {showCheckbox && (
        <Box
          sx={{ position: "absolute", top: 4, left: 4 }}
          onClick={e => {
            e.stopPropagation()
            onSelect(image)
          }}>
          <Checkbox
            checked={selected}
            size="small"
            sx={{
              p: 0.5,
              color: "white",
              bgcolor: selected ? "transparent" : "rgba(0,0,0,0.4)",
              borderRadius: "50%",
              "&.Mui-checked": { color: "primary.main" }
            }}
          />
        </Box>
      )}
    </Box>
  )
}

export default GalleryImageTile
